export default "__VITE_ASSET__C_0cdZdu__"